import { render, staticRenderFns } from "./timespent-card.vue?vue&type=template&id=46e408c0&scoped=true"
import script from "./timespent-card.ts?vue&type=script&lang=ts&external"
export * from "./timespent-card.ts?vue&type=script&lang=ts&external"
import style0 from "./timespent-card.scss?vue&type=style&index=0&id=46e408c0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e408c0",
  null
  
)

export default component.exports